import styled from "styled-components";

import { colors, zIndex } from "src/assets/styles/settings";
import classNames from "classnames";

export const ApplicationTemplate = styled.div`
  background: transparent;
  display: flex;
  min-height: 100vh;
  padding: 0;
`;

export const ContentBox = styled.div`
  display: inline-block;
  padding-left: 256px;
  transition: 0.3s ease;
  width: 100%;

  @media (max-width: 576px) {
    padding-left: 76px;
  }
`;

export const Backdrop = styled.div`
  visibility: hidden;

  @media (max-width: 576px) {
    visibility: ${({ collapsed }) => (!!collapsed ? "hidden" : "visible")};
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: ${zIndex.backdrop};
  }
`;

export const ContWrapper = styled.div`
  background-color: ${({ bgMain }) => (bgMain ? colors.main_background : colors.white)};
`;

export const TopBarContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  transition: right 0.3s ease;
`;

export const ContentWrapper = ({ className, children, ...props }) => (
  <div className={classNames(className, "u-transition-all u-px-6")} {...props}>
    {children}
  </div>
);
